import { Search as SearchIcon } from '@mui/icons-material';
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  styled,
  TextField,
  TextFieldProps,
} from '@mui/material';

export const Wrapper = styled(FormGroup)`
  overflow: hidden;

  & div {
    width: 100%;
    overflow: hidden;
  }
`;

export const Label = styled(FormControlLabel)`
  width: 100%;
  overflow: hidden;

  .MuiFormControlLabel-label {
    width: calc(100% - 40px);
    font-weight: 300;
  }
`;

export const CheckboxField = styled(Checkbox)`
  padding: 5px 7px 5px 9px;
`;

export const SearchBar = (props: TextFieldProps) => (
  <TextField
    variant="outlined"
    size="small"
    sx={{ padding: '5px 5px 5px 0' }}
    {...props}
    InputProps={{
      startAdornment: <SearchIcon sx={{ marginRight: '5px' }} />,
    }}
  />
);
